import styled from 'styled-components';

import { ThemeProp } from '../../theme/Themes';
import { setSVGChildColors } from '../../utils/Listings';
import Button from '../Button';
import IconButton from '../Button/IconButton';

export const Container = styled.div`
  display: flex;
  flex-direction: row;
  gap: 0.5rem;
`;

interface IconButtonProps {
  $selected?: boolean;
}
export const StyledIconButton = styled(IconButton)<IconButtonProps>`
  width: 2rem;
  height: 2rem;
  border-radius: 0.25rem;
  background: ${(props: ThemeProp & IconButtonProps) =>
    props.$selected ? props.theme.colors.primary.c800 : 'transparent'};
  :hover {
    background: ${(props) => props.theme.colors.primary.c800};
    ${(props: ThemeProp) => setSVGChildColors(props.theme.colors.primary.c200)}
  }
  ${(props: ThemeProp & IconButtonProps) =>
    props.$selected
      ? setSVGChildColors(props.theme.colors.primary.c200)
      : setSVGChildColors(props.theme.colors.greyscale.c700)}
`;

export const StyledButton = styled(Button)<IconButtonProps>`
  border-radius: 0.5rem;
  border: 1px solid
    ${(props) => (props.$selected ? props.theme.colors.primary.c200 : props.theme.colors.greyscale.c800)};
  background: ${(props: ThemeProp & IconButtonProps) =>
    props.$selected ? props.theme.colors.primary.c800 : 'transparent'};
  :hover {
    background: ${(props) => props.theme.colors.primary.c800};
    ${(props: ThemeProp) => setSVGChildColors(props.theme.colors.primary.c200)}
    p {
      color: ${(props) => props.theme.colors.primary.c200};
    }
  }
  :focus {
    background: ${(props) => props.theme.colors.primary.c800};
    ${(props: ThemeProp) => setSVGChildColors(props.theme.colors.primary.c200)}
    p {
      color: ${(props) => props.theme.colors.primary.c200};
    }
  }
  ${(props: ThemeProp & IconButtonProps) =>
    props.$selected
      ? setSVGChildColors(props.theme.colors.primary.c200)
      : setSVGChildColors(props.theme.colors.greyscale.c200)}

  ${(props: ThemeProp & IconButtonProps) =>
    props.$selected
      ? ` p { color: ${props.theme.colors.primary.c200}; }`
      : `p { color: ${props.theme.colors.greyscale.c200}; }`}
`;
